import React from "react";
import clsx from "clsx";
import {SOURCE_COUNTER_CLASS, getStatusStyle} from "../utils/dashboard-config.js";
import {FaCar} from "react-icons/fa";
import {FaPerson} from "react-icons/fa6";

const DashboardCounterGroup = ({title, items, counts = {}, activeValue, onChange, variant = "status", showShortLabel = false, showIconLabel = false}) => (
    <div className="flex shrink-0 flex-col gap-1">
        <span className="text-[13px] leading-none text-[#676a6c]">{title}</span>
        <div className="flex flex-wrap gap-0.5">
            {items.map(item => {
                const active = activeValue === item.key;
                const count = counts[item.countKey ?? item.key] ?? 0;
                const colorClass = variant === "status" ? getStatusStyle(item.key).counter : SOURCE_COUNTER_CLASS;

                const buttonChildren =
                    showIconLabel
                        ? (item.key === "WITH_VEHICLE" ? <FaCar size={14}/> : <FaPerson size={14}/>)
                        : (showShortLabel ? item.shortLabel : count);

                return (
                    <button
                        key={item.key}
                        type="button"
                        title={item.label}
                        aria-label={item.label}
                        onClick={() => onChange(active ? null : item.key)}
                        className={clsx(
                            "h-7 w-7 rounded-[3px] border px-1 text-center text-[14px] font-bold leading-5 cursor-pointer flex items-center justify-center",
                            "focus:outline-none focus:ring-1 focus:ring-[#02486b]",
                            colorClass,
                            active && "shadow-[0_0_3px_2px_rgba(58,58,58,1)] opacity-90",
                        )}
                    >
                        {buttonChildren}
                    </button>
                );
            })}
        </div>
    </div>
);

export default DashboardCounterGroup;
